"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Search/Refined/ResultRow.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _time = require('shared/services/time');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _InboxItemAvatar = require('web/screens/Inbox/InboxItemAvatar'); var _InboxItemAvatar2 = _interopRequireDefault(_InboxItemAvatar);

var _icons = require('./icons');
var _model = require('./model');










const Snippet = ({ text, query }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _model.splitOnQuery.call(void 0, text, query).map((part, i) => (i % 2 === 1
      ? _react2.default.createElement('mark', { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}, part)
      : _react2.default.createElement(_react2.default.Fragment, { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}, part)))
  )
)

const fileTag = (name) => {
  const ext = name.split('.').pop()
  return ext && ext !== name ? ext.slice(0, 4).toUpperCase() : 'FILE'
}

/**
 * One search result. Chat rows show the chat and its matching description;
 * message rows show who sent it (when the server says), "in {chat}" and the
 * date; file rows show the file name and its chat.
 */
const ResultRow = ({ item, query, active, onOpen, onHover }) => {
  const open = _react.useCallback.call(void 0, () => onOpen(item), [onOpen, item])
  const hover = _react.useCallback.call(void 0, () => onHover(item.id), [onHover, item.id])
  const isFile = item.group === 'files'
  const heading = isFile ? item.text : (item.senderName || item.chatName)
  const inChat = item.group === 'chats' ? null : (isFile || item.senderName ? item.chatName : null)

  return (
    _react2.default.createElement('li', {
      id: `search-result-${item.id}`,
      role: "option",
      'aria-selected': active,
      className: _classBuilder2.default.call(void 0, 'search-window--row', active && 'search-window--row---active'),
      onClick: open,
      onMouseMove: hover, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}

      , _react2.default.createElement('span', { className: "search-window--row-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
        , isFile
          ? _react2.default.createElement('span', { className: "search-window--file-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, fileTag(item.text))
          : _react2.default.createElement(_InboxItemAvatar2.default, { bkey: item.bKey, size: 32, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}} )
      )
      , _react2.default.createElement('span', { className: "search-window--row-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
        , _react2.default.createElement('span', { className: "search-window--row-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, isFile ? _react2.default.createElement(Snippet, { text: heading, query: query, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} ) : heading)
          , inChat && _react2.default.createElement('span', { className: "search-window--row-in", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "in " , inChat)
          , _react2.default.createElement('time', { dateTime: item.timestamp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, _time.getDateString.call(void 0, item.timestamp))
        )
        , !isFile && item.text && (
          _react2.default.createElement('span', { className: "search-window--row-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, _react2.default.createElement(Snippet, { text: item.text, query: query, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} ))
        )
      )
      , active && _react2.default.createElement('span', { className: "search-window--row-enter", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, _react2.default.createElement(_icons.EnterIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}} ))
    )
  )
}

exports. default = _react.memo.call(void 0, ResultRow)
